<template>
  <v-row>
    <v-col cols="12" md="8" offset-md="1">
      <v-row>
        <v-col cols="12" class="my-16">
          <h1
            class="secondary--text text-center text-md-left display-2 font-weight-black "
          >
            {{ $t('portal.general.app_list.labels.title') }}
            <span>
              <b class="primary--text">{{
                $t('portal.general.app_list.labels.strix')
              }}</b>
            </span>
          </h1>
          <p
            v-if="$t('portal.general.app_list.labels.subtitle')"
            class="secondary--text headline font-weight-bold mt-4 pl-1"
          >
            {{ $t('portal.general.app_list.labels.subtitle') }}
          </p>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" lg="12">
          <div class="d-flex flex-wrap justify-center justify-md-start">
            <div
              class="pill-wrapper text-center"
              v-for="item in appItems"
              :key="item.title"
              :title="item.title"
            >
              <v-btn height="auto" text @click="pushPath(item)">
                <SvgPill :iconType="item.pill" />
              </v-btn>

              <div class="pill-text secondary--text mt-2">{{ item.title }}</div>
            </div>
            <div
              class="pill-wrapper text-center"
              :title="$t('portal.general.app_list.labels.apps.maintenance')"
            >
              <v-btn
                :disabled="loading"
                :loading="loading"
                height="auto"
                text
                @click="connectToMaintenanceService()"
              >
                <SvgPill iconType="pill_maintenance" />
              </v-btn>
              <div class="pill-text secondary--text mt-2">
                {{ $t('portal.general.app_list.labels.apps.maintenance') }}
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { SvgPill, firebaseServices } from '@leapsight/styleguide'
import i18n from '@/plugins/i18n'
import firebaseTagNames from '@/constants/firebaseTagNames'
import { MaintenanceHelpers } from '@/helpers/mainExports'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'AppList',
  components: {
    SvgPill
  },
  data() {
    return {
      appItems: [
        {
          pill: 'pill_fleet_mgnt',
          enabled: true,
          path: 'fleet-management',
          title: i18n.t('portal.general.app_list.labels.apps.fleet_management'),
          logEvent: () =>
            firebaseServices.logEvent(
              firebaseServices.analytics,
              firebaseTagNames.BTN_PORTAL_DASHBOARD_FLEET_MANAGEMENT
            )
        },
        {
          pill: 'pill_live_track',
          enabled: true,
          path: 'live-tracking',
          title: i18n.t('portal.general.app_list.labels.apps.live_tracking'),
          logEvent: () =>
            firebaseServices.logEvent(
              firebaseServices.analytics,
              firebaseTagNames.BTN_PORTAL_DASHBOARD_LIVE_TRACKING
            )
        },
        {
          pill: 'pill_reports',
          enabled: true,
          path: 'reports',
          title: i18n.t('portal.general.app_list.labels.apps.reports'),
          logEvent: () =>
            firebaseServices.logEvent(
              firebaseServices.analytics,
              firebaseTagNames.BTN_PORTAL_DASHBOARD_REPORTS
            )
        }
      ],
      loading: false
    }
  },
  methods: {
    ...mapActions('auth', ['establishConnection']),
    pushPath(service) {
      this.appItems.find(app => app.path === service.path).logEvent()
      window.location.href = `${window.location.origin}/${service.path}`
    },
    async connectToMaintenanceService() {
      this.loading = true
      const response = await MaintenanceHelpers.connectToMaintenanceService()
      if (response.error) {
        const snackbar = {
          show: true,
          color: 'error',
          text: i18n.t(
            'portal.login.login.errors.maintenance_service_unreachable'
          )
        }
        this.$store.commit('ui/setSnackbar', snackbar)
      } else {
        window.open(response, '_newtab')
      }
      this.loading = false
    }
  },
  computed: {
    ...mapGetters('auth', ['session', 'connection']),
    ...mapGetters('ui', ['snackbar'])
  },
  async created() {
    try {
      if (this.$route.name === 'launcher' && !this.session.isOpen) {
        await this.establishConnection()
      }
    } catch (error) {
      console.error(error)
    }
  }
}
</script>

<style>
.pill-text {
  font-size: 1.062rem;
}

.pill-wrapper .theme--light.v-btn:hover::before {
  opacity: 0;
}

.pill-wrapper .theme--light.v-btn:hover::before,
.pill-wrapper .theme--light.v-btn:focus::before {
  opacity: 0 !important;
}

.pill-wrapper .v-ripple__container {
  display: none !important;
}

.pill-wrapper .svg-pill {
  transition: all 0.2s ease-in-out;
}

.pill-wrapper .svg-pill:hover {
  transform: scale(1.1);
}
</style>
